export default () => {
  const loaded =
    document.readyState == 'complete' || document.readyState == 'loaded';

  const lazyLoadEvent = () => {
    const showFull = (img) =>
      setTimeout(() => (img.closest('[data-lazy]').dataset.lazy = 1), 100);

    const addLoadOrShow = (img) => {
      img.src = img.dataset.lazyFull;
      if (img.complete && img.naturalHeight !== 0) return showFull(img);
      return img.addEventListener('load', ({ target }) => showFull(target));
    };

    // sets the intersection area 300px top and bottom of viewport so that images are loaded before
    // they are in view.
    const options = {
      root: null,
      rootMargin: "300px 0px 300px 0px",
      threshold: 0
    };

    const callback = (entries) => {
      entries.map(
        (entry) =>
          (entry.isIntersecting || entry.intersectionRatio > 0) && addLoadOrShow(entry.target)
      );
    };

    const observer = new IntersectionObserver(callback, options);

    [...document.querySelectorAll('[data-lazy-full]')].map((img) => observer.observe(img));
  };

  if (loaded) return lazyLoadEvent();
  document.addEventListener('vue:loaded', lazyLoadEvent);
  document.addEventListener('DOMContentLoaded', lazyLoadEvent);
};
